export default class CountdownTimer {
  constructor() {
    this.selector = '#timer-1';
    this.targetDate = null;
    this.intervalId = null;
  }

  getRefs() {
    return {
      days: document.querySelector(`${this.selector} [data-value='days']`),
      hours: document.querySelector(`${this.selector} [data-value='hours']`),
      mins: document.querySelector(`${this.selector} [data-value='mins']`),
      secs: document.querySelector(`${this.selector} [data-value='secs']`),
    };
  }

  updateDate(date) {
    this.stopTimer();
    this.targetDate = date instanceof Date ? date : new Date(date);

    if (Number.isNaN(this.targetDate.getTime())) {
      return;
    }

    this.render();
    this.intervalId = setInterval(() => this.render(), 1000);
  }

  render() {
    const { days, hours, mins, secs } = this.getRefs();

    if (!days || !hours || !mins || !secs) {
      return;
    }

    const time = this.targetDate - Date.now();

    if (time < 0) {
      this.stopTimer();
      days.textContent = '00';
      hours.textContent = '00';
      mins.textContent = '00';
      secs.textContent = '00';
      return;
    }

    days.textContent = this.pad(Math.floor(time / (1000 * 60 * 60 * 24)));
    hours.textContent = this.pad(Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    mins.textContent = this.pad(Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)));
    secs.textContent = this.pad(Math.floor((time % (1000 * 60)) / 1000));
  }

  pad(value) {
    return String(value).padStart(2, '0');
  }

  stopTimer() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }
}
